import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import Blocking from '../Blocking/Blocking.js';
import BlockSummary from '../BlockSummary/BlockSummary.js';
import ThinkAloud from '../ThinkAloud/ThinkAloud.js';
import Guide from '../Guide/Guide.js';
import PressurePoint from '../PressurePoint/PressurePoint.js';
import Reflection from '../Reflection/Reflection.js';
import { Card } from 'antd';
import Transition from '../Misc/Transition.js';



class CourseLesson extends Component {

  renderLesson(){
    //renders nothin until start clicked
    if(!this.props.course.mountLesson){
      return null;
    }

    let lesson;

    const props = {
      data: this.props.componentData
    };

    switch(this.props.lesson.component){
      case 'Blocking':
        lesson = <Blocking {...props} />;
        break;
      case 'BlockSummary':
        lesson = <BlockSummary {...props} />;
        break;
      case 'Guide':
        lesson = <Guide {...props} />;
        break;
      case 'ThinkAloud':
        lesson = <ThinkAloud {...props} />;
        break;
      case 'PressurePoint':
        lesson = <PressurePoint {...props} />;
        break;
      case 'Reflection':
        lesson = <Reflection {...props} />;
        break;
      default:
        lesson = null;
        break;
    }
    return (
      <Card bodyStyle={{minHeight: this.props.minHeight /2}} id="CourseLesson" key="lesson" hoverable={true}>
        {lesson}
      </Card>
    )
  }

  render() {
    return (
      <Transition>
        {this.renderLesson()}
      </Transition>
    )
  }
}

function mapStateToProps(state) {
  return {
    course: state.course,
    lesson: state.course.lesson,
    componentData : state.course.lesson.componentData
  };
}

export default connect(mapStateToProps, actions)(CourseLesson);



// WEBPACK FOOTER //
// ./src/components/Course/CourseLesson.js